<app-header [title]="'CASES.HEADER.TITLE' | translate"></app-header>
<main id="cases-container">
  <payee-cases
    [getCasesPath]="getCasesPath"
    [getDebtorsPath]="getDebtorsPath"
  ></payee-cases>
</main>
